import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Check if it's a ResizeObserver error - these are benign
    if (
      error.message &&
      (error.message.includes('ResizeObserver loop limit exceeded') ||
       error.message.includes('ResizeObserver loop completed with undelivered notifications'))
    ) {
      // Don't set error state for ResizeObserver errors
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Check if it's a ResizeObserver error - suppress it
    if (
      error.message &&
      (error.message.includes('ResizeObserver loop limit exceeded') ||
       error.message.includes('ResizeObserver loop completed with undelivered notifications'))
    ) {
      // Silently ignore ResizeObserver errors
      return;
    }
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError && this.state.error) {
      return (
        <div style={{ padding: '20px', color: '#E2E8F0', background: '#161B22', minHeight: '100vh' }}>
          <h1>Something went wrong.</h1>
          <p>{this.state.error.message}</p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              padding: '10px 20px',
              background: '#22D3EE',
              color: '#0D1117',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              marginTop: '10px',
            }}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

